import { Grid } from '@mui/material';
import React from 'react';
import { APP_ROUTES } from '../../../common/constants/Routes';
import { useForm } from 'react-hook-form';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../../common/Header';
import TankFrom from './TankFrom';
import { useTranslation } from 'react-i18next';

function ViewTank() {
  const { t } = useTranslation();
  const location = useLocation();
  const { register, handleSubmit, control } = useForm({
    defaultValues: {
      tank_capacity: location.state.data?.data?.tank_capacity || '',
      name: location.state.data?.data?.name || '',
    },
  });
  const navigate = useNavigate();
  const onSubmit = (data: any) => {
    console.log(data);
    navigate(APP_ROUTES.TANK);
  };
  return (
    <Grid container mb={5}>
      <Grid xs={12} p={2}>
        <Header
          view={true}
          header={t('VIEW_TANK')}
          route={APP_ROUTES.TANK}
          buttonName={t('GO_BACK')}
          buttonIcon={SubdirectoryArrowRightIcon}
        />
      </Grid>
      <Grid xs={12}>
        <TankFrom
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          control={control}
          register={register}
          view={true}
        />
      </Grid>
    </Grid>
  );
}

export default ViewTank;
